/* ==========================================================
   src/app/app.component.ts
   ----------------------------------------------------------
   Refactor para usar NetworkCoreService directamente
   + OPTIMIZACIÓN DE ARRANQUE (NON-BLOCKING INIT)
   ========================================================== */

   import { Component } from '@angular/core';
   import { Platform } from '@ionic/angular';
   import { Storage } from '@ionic/storage-angular';
   import { Router } from '@angular/router';
   import { distinctUntilChanged } from 'rxjs/operators';
   
   import { AuthService } from 'src/app/core/services/auth/auth.service';
   import { DeviceCoreService, DeviceInfoModel } from 'src/app/core/system/device-core.service';
   import { DeviceApiService } from 'src/app/core/system/api-device/device-api.service';
   import { SyncCoreService } from 'src/app/core/localdata/sync/sync-core.service';
   import { PendingCoreService } from 'src/app/core/localdata/pending/pending-core.service';
   import { SqliteConexionService } from 'src/app/core/localdata/core-sqlite-services/sqlite-conexion.service';
   import { NetworkCoreService } from 'src/app/core/system/network-core.service';
   
   @Component({
     selector: 'app-root',
     templateUrl: 'app.component.html',
     styleUrls: ['app.component.scss'],
   })
   export class AppComponent {
   
    currentUser: any = null;

     // =========================================================
     // 🔹 INICIO CAMBIO: flag para evitar reconstrucción múltiple
     // =========================================================
     private menuBuilt = false;
     // =========================================================
     // 🔹 FIN CAMBIO
     // =========================================================
   
     // =========================================================
     // 🔹 INICIO CAMBIO: control de usuario actual
     // =========================================================
     private lastUserId: any = null;
     // =========================================================
     // 🔹 FIN CAMBIO
     // =========================================================
   
    // =========================================================
    // 🔹 INICIO CAMBIO: método logout desacoplado
    // =========================================================
    logout() {
      console.log('🔒 Cerrando sesión desde UI');

      // 🔹 SOLO cambia estado → arquitectura reactiva
      this.authService.logout();
    }
    // =========================================================
    // 🔹 FIN CAMBIO
    // ===

     // =========================================================
     // 🔹 INICIO CAMBIO: helper para identificar usuario
     // =========================================================
     private getUserIdentifier(user: any): string {
       return user?.login || '';
     }
     // =========================================================
     // 🔹 FIN CAMBIO
     // =========================================================
   
     public appPages = [
       { title: 'Login', url: '/auth/login', icon: 'log-in' },
       { title: 'Crear Pedido', url: '/create-commande', icon: 'cube' },
       { title: 'Inbox', url: '/folder/Inbox', icon: 'mail' },
       { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
     ];
   
     public clientesChildren = [];
     public adminChildren = [];
     public productosChildren = [];
     public inventoryChildren = [];
     public posChildren = [];
     public financeChildren = [];
     public reportingChildren = [];
     public isOnline: boolean = true;
   
     constructor(
       private platform: Platform,
       private storage: Storage,
       private authService: AuthService,
       private router: Router,
       private deviceCore: DeviceCoreService,
       private deviceApi: DeviceApiService,
       private sqliteService: SqliteConexionService,
       private syncCore: SyncCoreService,
       private pendingCore: PendingCoreService,
       private networkCore: NetworkCoreService
     ) {
       this.initializeApp();
     }
   
     async initializeApp() {
       await this.platform.ready();
   
       // =========================================================
       // 🔹 INICIO CAMBIO: INIT MÍNIMO (NO BLOQUEAR UI)
       // =========================================================
       await this.initMinimalApp();
       // =========================================================
       // 🔹 FIN CAMBIO
       // =========================================================
   
       // =========================================================
       // 🔹 INICIO CAMBIO: SERVICIOS PESADOS EN BACKGROUND
       // =========================================================
       this.initBackgroundServices();
       // =========================================================
       // 🔹 FIN CAMBIO
       // =========================================================
   
       // 🔹 Suscripción al estado de red
       this.networkCore.isOnline$.pipe(distinctUntilChanged()).subscribe((connected) => {
         this.isOnline = connected;
         console.log(`[AppComponent] Estado de red: ${connected ? 'Online' : 'Offline'}`);
   
         if (connected) {
           setTimeout(() => {
             this.syncAfterConnection();
           }, 3000);
         }
       });
   
       // 🔥 =========================================================
       // 🔹 INICIO CAMBIO: FIX MENÚ POR USUARIO (CRÍTICO)
       // =========================================================
       this.authService.currentUser$.subscribe((user) => {
   
        this.currentUser = user

         console.log('👤 Usuario cambiado:', user);
   
         // 🔹 SI NO HAY USUARIO
         if (!user) {
   
           this.menuBuilt = false;
           this.lastUserId = null;
   
           this.router.navigate(['/auth/login']);
   
           this.adminChildren = [];
           this.clientesChildren = [];
           this.productosChildren = [];
           this.inventoryChildren = [];
           this.posChildren = [];
           this.financeChildren = [];
           this.reportingChildren = [];
   
           return;
         }
   
         // 🔹 DETECTAR CAMBIO DE USUARIO (FIX APLICADO)
         const currentUserId = this.getUserIdentifier(user);
   
         if (this.lastUserId !== currentUserId) {
   
           console.log('🔄 Usuario diferente → reconstruyendo menú');
   
           this.lastUserId = currentUserId;
           this.menuBuilt = false;
   
           // limpiar menús
           this.adminChildren = [];
           this.clientesChildren = [];
           this.productosChildren = [];
           this.inventoryChildren = [];
           this.posChildren = [];
           this.financeChildren = [];
           this.reportingChildren = [];
         }
   
         // 🔹 CONSTRUIR MENÚ
         if (!this.menuBuilt) {
   
           this.menuBuilt = true;
   
           this.buildClientesMenu();
           this.buildAdminMenu();
           this.buildProductosMenu();
           this.buildInventoryMenu();
           this.buildPosMenu();
           this.buildFinanceMenu();
           this.buildReportingMenu();
   
           console.log('✅ Menú construido correctamente');
         }
       });
       // =========================================================
       // 🔹 FIN CAMBIO
       // =========================================================
   
       // 🔹 Limpieza antes de cerrar la app
       window.addEventListener('beforeunload', async () => {
         try {
           await this.storage.remove('currentUser');
           console.log('[AppComponent] Storage limpiado antes de cerrar la pestaña');
         } catch (err) {
           console.error('[AppComponent] Error limpiando Storage:', err);
         }
       });
     }
   
     // =========================================================
     // 🔹 INICIO CAMBIO: INIT MÍNIMO
     // =========================================================
     private async initMinimalApp() {
       try {
         await this.storage.create();
   
         const savedUser = await this.storage.get('currentUser');
   
         if (savedUser) {
           await this.authService.setCurrentUser(savedUser);
           console.log('[AppComponent] Usuario cargado rápido');
         } else {
           this.router.navigate(['/auth/login']);
         }
   
       } catch (err) {
         console.error('[AppComponent] initMinimalApp error:', err);
       }
     }
     // =========================================================
     // 🔹 FIN CAMBIO
     // =========================================================
   
     // =========================================================
     // 🔹 INICIO CAMBIO: BACKGROUND SERVICES
     // =========================================================
     private initBackgroundServices() {
   
       this.sqliteService.initAllSchemas()
         .then(() => console.log('[AppComponent] SQLite listo (background)'))
         .catch(err => console.error(err));
   
       this.deviceCore.getDeviceInfo()
         .then(info => this.deviceApi.registerOrUpdateDevice(info))
         .then(() => console.log('[AppComponent] Device OK (background)'))
         .catch(err => console.error(err));
     }
     // =========================================================
     // 🔹 FIN CAMBIO
     // =========================================================
   
     private async syncAfterConnection() {
       console.log('[AppComponent] 🔄 Sincronización automática iniciada...');
       try {
         await this.syncCore.syncAll();
         await this.pendingCore.syncPendingOps(async (op) => {
           console.log('📤 Procesando operación pendiente:', op);
         });
         console.log('[AppComponent] ✅ Sincronización completada.');
       } catch (err) {
         console.error('[AppComponent] ❌ Error en sincronización automática:', err);
       }
     }
   
     // ===== MENÚS (NO TOCADOS) =====
   
     private buildClientesMenu() {
       const menu = [
         { title: 'Crear Cliente', url: '/clientes/create-client', icon: 'add-circle', perm: 'create_client' },
         { title: 'Listar Clientes', url: '/clientes/list-client', icon: 'list', perm: 'list_client' },
         { title: 'Edit Cliente', url: '/clientes/edit-client', icon: 'create', perm: 'edit_client' },
       ];
       this.clientesChildren = menu.filter((item) => this.authService.hasPermission(item.perm));
     }
   
     private buildAdminMenu() {
       const menu = [
         { title: 'Dashboard Admin', url: '/admin', icon: 'settings', perm: 'admin_access' },
         { title: 'Crear Usuario', url: '/admin/users/create-user', icon: 'person-add', perm: 'admin_access' },
         { title: 'Listar Usuarios', url: '/admin/users/list-user', icon: 'people', perm: 'admin_access' },
       ];
       this.adminChildren = menu.filter((item) => this.authService.hasPermission(item.perm));
     }
   
     private buildProductosMenu() {
       const menu = [
         { title: 'Crear Producto', url: '/productos/create-product', icon: 'cube', perm: 'create_product' },
         { title: 'Listar Productos', url: '/productos/list-product', icon: 'list', perm: 'list_product' },
         { title: 'Lista Precios Producto', url: '/productos/product-prices/1', icon: 'cash', perm: 'list_product_price' },
       ];
       this.productosChildren = menu.filter((item) => this.authService.hasPermission(item.perm));
     }
   
     private buildInventoryMenu() {
       const menu = [
         { title: 'Stock por Producto', url: '/inventory/stock/stock-by-product', icon: 'archive', perm: 'view_inventory_stock' },
         { title: 'Productos y stock', url: '/inventory/stock/stock-list', icon: 'list', perm: 'list_product_stocks' },
         { title: 'Movimiento de Stock', url: '/inventory/movements/create', icon: 'swap-vertical', perm: 'create_movement' },
         { title: 'Alertas de Stock', url: '/inventory/stock-alerts', icon: 'alert-circle', perm: 'stock_alerts' },
       ];
   
       this.inventoryChildren = menu.filter(item =>
         this.authService.hasPermission(item.perm)
       );
     }
   
     private buildPosMenu() {
       const menu = [
         { title: 'Abrir Caja / POS', url: '/pos/select-store', icon: 'storefront', perm: 'view_select_store' },
         { title: 'Control de Caja', url: '/pos/cash-session-control', icon: 'cash', perm: 'mod_pos' },
       ];
   
       this.posChildren = menu.filter(item =>
         this.authService.hasPermission(item.perm)
       );
     }
   
     private buildFinanceMenu() {
       const menu = [
         { title: 'Movimientos de Caja', url: '/finance/home', icon: 'cash', perm: 'view_cash_movements' },
         { title: 'Registrar Movimiento', url: '/finance/select-store', icon: 'add-circle', perm: 'mod_pos' }
       ];
   
       this.financeChildren =
         menu.filter(item =>
           this.authService.hasPermission(item.perm)
         );
     }
   
     private buildReportingMenu() {
       const menu = [
         { title: 'Reporte Sesiones de Caja', url: '/reporting/cash-session-report', icon: 'analytics', perm: 'view_cash_sessions_report' },
         { title: 'Reporte de Caja Diario', url: '/reporting/daily-cash-summary-report', icon: 'analytics', perm: 'view_daily_cash_summary' }
       ];
   
       this.reportingChildren =
         menu.filter(item =>
           this.authService.hasPermission(item.perm)
         );
     }
   }